

































import { Component, Vue, Emit, Prop } from 'vue-property-decorator'
import {  AddVoucherModel, QuerySupplierList, QueryVoucherModelById, UpdateVoucherModel } from '@/api'
import { Message } from 'element-ui'
import { ElForm } from 'element-ui/types/form'
import { getByParentId } from '@/store/classifyStore'
import { VImageUpload } from '@/components/upload'
import constant from '@/utils/constant'

@Component({
  components: {
    VImageUpload,
  },
})
export default class EditVoucherModel extends Vue {
  @Prop({ type: Boolean, default: false }) private isEdit!: boolean
  private show = false
  private data: any = {
    status: 1
  }
  private statusOp = constant.Status
  private requiredRule = { required: true, message: '不能为空', trigger: 'blur' }
  private rules = {
    voucherName: [this.requiredRule],
    specifiedSupplierCode: [this.requiredRule],
  }

  private supplierOption: Array<any> = []

  public async created(){
    const res = await QuerySupplierList({})
    const list =  res.list
    this.supplierOption = list.map((e: any)=>{
      return {value: e.supplierCode,label:e.supplierSimpleName}
    })
  }

  private classifyTree(parentId: number) {
    return getByParentId(parentId)
  }

  @Emit('close')
  private close() {
    this.show = false
    const f = this.$refs.form as ElForm
    f.resetFields()
    this.data = {}
  }
  @Emit('refresh')
  private refresh() {
    return {}
  }

  public async open(param: any) {
    // id
    if(this.isEdit){
      const id = param.id
      if(id){
        await this.loadData(id)
      } else {
        Message.error('请选择数据')
        return
      }
    } else {
      this.data.useType = param.useType
    }

    this.show = true
    
  }

  private async loadData(id: any){
    const res = await QueryVoucherModelById({id});
    this.data = res
  }

  public async save() {
    const f = this.$refs.form as ElForm
    f.validate(async (success: boolean) => {
      if (!success) {
        return
      }
      const param = {...this.data}

      const t = this.supplierOption.filter(e=>e.value == param.specifiedSupplierCode)
      param.supplierSimpleName = t[0].label
      
      if (this.isEdit) {
        await UpdateVoucherModel(param)
      } else {
        await AddVoucherModel(param)
      }

      this.refresh()
      Message.success('保存')
      this.close()
    })
  }
}
